import styled from 'styled-components';

const BenchLogo = styled.img`
  display: block;
  height: 32px;
`;

export default BenchLogo;
